module.exports = __webpack_public_path__ + "img/salt_2.96a4ebf9.png";